import ArmorTypes from './RosterStats/ArmorTypes'
import CountByClass from './RosterStats/CountByClass'
import CountByRole from './RosterStats/CountByRole'
import TierTokens from './RosterStats/TierTokens'
import TotalCharacters from './RosterStats/TotalCharacters'

const RosterStats = () => {
  return (
    <div className='max-xl:pt-4 xl:border-l-2 xl:pl-4'>
      <h4 className='mb-2 xl:hidden'>Setup</h4>
      <div className='max-xl:grid max-[530px]:grid-cols-1 max-md:grid-cols-2 max-xl:grid-cols-3 xl:flex xl:flex-col gap-2'>
        <div className='flex flex-col gap-2 grow'>
          <TotalCharacters />
          <CountByRole />
        </div>

        <div className='flex flex-col gap-2 [&>div]:grow grow'>
          <ArmorTypes />
          <TierTokens />
        </div>

        <div className='grow'>
          <CountByClass />
        </div>
      </div>
    </div>
  )
}

export default RosterStats
